import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "create-driver-modal",
  role: "dialog",
  class: "modal fade cdm-modal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered cdm-dialog",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "cdm-header" }
const _hoisted_5 = { class: "cdm-header-info" }
const _hoisted_6 = { class: "cdm-title" }
const _hoisted_7 = { class: "cdm-subtitle" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "cdm-body" }
const _hoisted_10 = { class: "cdm-photo-row" }
const _hoisted_11 = { class: "cdm-photo-wrap" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "fas fa-user"
}
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "cdm-field-label mb-0" }
const _hoisted_16 = { class: "cdm-photo-hint" }
const _hoisted_17 = {
  key: 0,
  class: "is-invalid cdm-photo-error"
}
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "cdm-field-label" }
const _hoisted_20 = { class: "input-group input-group-sm" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "cdm-field-label" }
const _hoisted_25 = { class: "input-group input-group-sm" }
const _hoisted_26 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_27 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "cdm-field-label" }
const _hoisted_30 = { class: "input-group input-group-sm" }
const _hoisted_31 = ["type", "onUpdate:modelValue", "placeholder"]
const _hoisted_32 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-sm-6" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "cdm-field-label" }
const _hoisted_37 = { class: "input-group input-group-sm" }
const _hoisted_38 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_39 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_40 = { class: "col-sm-6" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = { class: "cdm-field-label" }
const _hoisted_43 = { class: "input-group input-group-sm" }
const _hoisted_44 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_45 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-sm-4" }
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = { class: "cdm-field-label" }
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "col-sm-8" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = { class: "cdm-field-label" }
const _hoisted_54 = { class: "input-group input-group-sm" }
const _hoisted_55 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_56 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_57 = { class: "row align-items-end" }
const _hoisted_58 = { class: "col-sm-6" }
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = { class: "cdm-field-label" }
const _hoisted_61 = { class: "form-check form-switch cdm-status-switch" }
const _hoisted_62 = {
  class: "form-check-label",
  for: "cdmEnableDriver"
}
const _hoisted_63 = { class: "col-sm-6" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = { class: "cdm-field-label" }
const _hoisted_66 = ["value"]
const _hoisted_67 = ["value"]
const _hoisted_68 = { class: "cdm-footer" }
const _hoisted_69 = ["disabled"]
const _hoisted_70 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_71 = {
  key: 1,
  class: "fas fa-paper-plane me-1"
}

import StorageService from '@/services/StorageService'
import { Field, Form } from 'vee-validate'
import { string, mixed, object, ObjectSchema } from 'yup'
import dayjs from 'dayjs'
import Driver from '@/models/Driver'
import DriverRepository from '@/repositories/DriverRepository'
import { Constants } from '@/constants/Constants'
import ToastService from '@/services/ToastService'
import { onBeforeUnmount, onMounted, ref, Ref, watch } from 'vue'
import { useDriversStore } from '@/services/stores/DriversStore'
import { useSettingsStore } from '@/services/stores/SettingsStore'
import { StrHelper } from '@/helpers/StrHelper'
import { DriverPaymentMode } from '@/constants/DriverPaymentMode'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateDriverModal',
  emits: ["close", "created"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const { t } = useI18n()
const driver: Ref<Driver> = ref(new Driver())
const password: Ref<string> = ref('')
const types: Array<string> = Constants.DOC_TYPES
const submitting = ref(false)
const showPassword = ref(false)
const photoFile = ref<File | null>(null)
const photoPreviewUrl = ref<string | null>(null)
const photoError = ref<string | null>(null)
const fileInputRef = ref<HTMLInputElement | null>(null)
const { addDriver } = useDriversStore()
const { branchSelected } = useSettingsStore()

const schema: ObjectSchema<any> = object().shape({
  name: string().required().min(3),
  email: string().required().email(),
  password: string().required().min(6),
  phone: string().required().min(8),
  phone2: string().nullable(),
  docType: mixed().oneOf(Constants.DOC_TYPES).required(),
  document: string().required().min(6).max(10),
  paymentMode: mixed().oneOf([DriverPaymentMode.MONTHLY, DriverPaymentMode.PERCENTAGE]).required(),
})

onMounted(() => {
  driver.value.docType = Constants.DOC_TYPE_CC
})

onBeforeUnmount(() => {
  if (photoPreviewUrl.value) {
    URL.revokeObjectURL(photoPreviewUrl.value)
  }
})

watch(driver, (newDriver) => {
  driver.value.name = StrHelper.toCamelCase(newDriver.name ?? '')
  driver.value.phone = StrHelper.formatNumber(newDriver.phone ?? '')
  driver.value.phone2 = StrHelper.formatNumber(newDriver.phone2 ?? '')
}, { deep: true })

function triggerFileInput(): void {
  fileInputRef.value?.click()
}

// photoUrl is intentionally kept out of the yup schema (optional field); validate manually
// only when a file is actually chosen, mirroring CustomValidator.image/size constraints.
function onPhotoChange(e: Event): void {
  const input = e.target as HTMLInputElement
  const file = input.files?.[0] ?? null
  if (!file) {
    return
  }
  if (!['image/jpeg', 'image/png'].includes(file.type)) {
    photoError.value = t('validations.image')
    input.value = ''
    return
  }
  if (file.size / 1024 / 1024 > 1.024) {
    photoError.value = t('validations.size')
    input.value = ''
    return
  }
  photoError.value = null
  if (photoPreviewUrl.value) {
    URL.revokeObjectURL(photoPreviewUrl.value)
  }
  photoFile.value = file
  photoPreviewUrl.value = URL.createObjectURL(file)
}

function onEnable(e: Event): void {
  const target = e.target as HTMLInputElement
  driver.value.enabled_at = target.checked ? dayjs().unix() : 0
}

function uploadPhoto(id: string, image: File): Promise<string> {
  const reference = StorageService.getStorageReference(StorageService.driverPath, id, image.name)
  return StorageService.uploadFile(reference, image)
}

function finishSuccess(): void {
  submitting.value = false
  addDriver(driver.value)
  ToastService.toast(ToastService.SUCCESS, t('common.messages.created'))
  emit('created')
  emit('close')
}

function handleError(e: any): void {
  submitting.value = false
  ToastService.toast(ToastService.ERROR, t('common.messages.error'), e.message)
}

function createDriver(): void {
  submitting.value = true
  driver.value.phone = (branchSelected?.calling_code ?? '') + driver.value.phone
  DriverRepository.create(driver.value, password.value).then((id) => {
    driver.value.id = id
    if (photoFile.value) {
      uploadPhoto(id, photoFile.value).then((url) => {
        driver.value.photoUrl = url
        return DriverRepository.update(driver.value)
      }).then(() => {
        finishSuccess()
      }).catch((e) => {
        handleError(e)
      })
    } else {
      finishSuccess()
    }
  }).catch((e) => {
    handleError(e)
  })
}

function close(): void {
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Form), {
          onSubmit: createDriver,
          "validation-schema": _unref(schema),
          class: "d-flex flex-column"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "cdm-icon-chip bg-gradient-primary d-flex align-items-center justify-content-center shadow-sm" }, [
                  _createElementVNode("em", { class: "fas fa-id-badge" })
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('drivers.forms.create_title')), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('drivers.forms.create_driver')), 1)
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "cdm-close-btn",
                "aria-label": _ctx.$t('common.actions.close'),
                onClick: close
              }, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("em", { class: "fas fa-xmark" }, null, -1)
              ]))], 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["cdm-photo-circle", { 'bg-gradient-primary': !photoPreviewUrl.value }])
                  }, [
                    (photoPreviewUrl.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: photoPreviewUrl.value,
                          alt: "",
                          class: "cdm-photo-img"
                        }, null, 8, _hoisted_12))
                      : (_openBlock(), _createElementBlock("em", _hoisted_13))
                  ], 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: "cdm-photo-btn bg-gradient-info shadow-sm",
                    title: _ctx.$t('drivers.placeholders.photo'),
                    onClick: triggerFileInput
                  }, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("em", { class: "fas fa-camera" }, null, -1)
                  ]))], 8, _hoisted_14),
                  _createElementVNode("input", {
                    ref_key: "fileInputRef",
                    ref: fileInputRef,
                    type: "file",
                    accept: "image/*",
                    class: "d-none",
                    onChange: onPhotoChange
                  }, null, 544)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('drivers.fields.photo')), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('drivers.placeholders.photo_hint')), 1),
                  (photoError.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(photoError.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('users.fields.name')), 1),
                _createVNode(_unref(Field), {
                  name: "name",
                  type: "text",
                  modelValue: driver.value.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((driver.value.name) = $event))
                }, {
                  default: _withCtx(({ field, errorMessage, meta }) => [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "input-group-text" }, [
                        _createElementVNode("em", { class: "fas fa-user" })
                      ], -1)),
                      _withDirectives(_createElementVNode("input", _mergeProps({ class: "form-control form-control-sm" }, field, {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((driver.value.name) = $event)),
                        placeholder: _ctx.$t('common.placeholders.name'),
                        "aria-label": "Name"
                      }), null, 16, _hoisted_21), [
                        [_vModelDynamic, driver.value.name]
                      ])
                    ]),
                    (errorMessage && meta.dirty)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('users.fields.email')), 1),
                _createVNode(_unref(Field), {
                  name: "email",
                  type: "email",
                  modelValue: driver.value.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((driver.value.email) = $event)),
                  autocomplete: "off"
                }, {
                  default: _withCtx(({ field, errorMessage, meta }) => [
                    _createElementVNode("div", _hoisted_25, [
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "input-group-text" }, [
                        _createElementVNode("em", { class: "fas fa-envelope" })
                      ], -1)),
                      _withDirectives(_createElementVNode("input", _mergeProps({ class: "form-control form-control-sm" }, field, {
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                        placeholder: _ctx.$t('common.placeholders.email'),
                        "aria-label": "Email"
                      }), null, 16, _hoisted_26), [
                        [_vModelDynamic, field.value]
                      ])
                    ]),
                    (errorMessage && meta.dirty)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('users.fields.password')), 1),
                _createVNode(_unref(Field), {
                  name: "password",
                  modelValue: password.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((password).value = $event))
                }, {
                  default: _withCtx(({ field, errorMessage, meta }) => [
                    _createElementVNode("div", _hoisted_30, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "input-group-text" }, [
                        _createElementVNode("em", { class: "fas fa-lock" })
                      ], -1)),
                      _withDirectives(_createElementVNode("input", _mergeProps({
                        type: showPassword.value ? 'text' : 'password',
                        class: "form-control form-control-sm"
                      }, field, {
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                        placeholder: _ctx.$t('users.fields.password'),
                        "aria-label": "Password"
                      }), null, 16, _hoisted_31), [
                        [_vModelDynamic, field.value]
                      ]),
                      _createElementVNode("span", {
                        class: "input-group-text cdm-eye-toggle",
                        role: "button",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (showPassword.value = !showPassword.value))
                      }, [
                        _createElementVNode("em", {
                          class: _normalizeClass(["fas", showPassword.value ? 'fa-eye-slash' : 'fa-eye'])
                        }, null, 2)
                      ])
                    ]),
                    (errorMessage && meta.dirty)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('users.fields.phone')), 1),
                    _createVNode(_unref(Field), {
                      name: "phone",
                      modelValue: driver.value.phone,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((driver.value.phone) = $event))
                    }, {
                      default: _withCtx(({ field, errorMessage, meta }) => [
                        _createElementVNode("div", _hoisted_37, [
                          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "input-group-text" }, [
                            _createElementVNode("em", { class: "fas fa-phone" })
                          ], -1)),
                          _withDirectives(_createElementVNode("input", _mergeProps({ class: "form-control form-control-sm" }, field, {
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            placeholder: _ctx.$t('common.placeholders.phone'),
                            "aria-label": "Phone"
                          }), null, 16, _hoisted_38), [
                            [_vModelDynamic, field.value]
                          ])
                        ]),
                        (errorMessage && meta.dirty)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(errorMessage), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('users.fields.phone2')), 1),
                    _createVNode(_unref(Field), {
                      name: "phone2",
                      modelValue: driver.value.phone2,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((driver.value.phone2) = $event))
                    }, {
                      default: _withCtx(({ field, errorMessage, meta }) => [
                        _createElementVNode("div", _hoisted_43, [
                          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "input-group-text" }, [
                            _createElementVNode("em", { class: "fas fa-phone" })
                          ], -1)),
                          _withDirectives(_createElementVNode("input", _mergeProps({ class: "form-control form-control-sm" }, field, {
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            placeholder: _ctx.$t('common.placeholders.phone2'),
                            "aria-label": "Phone 2"
                          }), null, 16, _hoisted_44), [
                            [_vModelDynamic, field.value]
                          ])
                        ]),
                        (errorMessage && meta.dirty)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(errorMessage), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t('drivers.fields.doc_type')), 1),
                    _createVNode(_unref(Field), {
                      name: "docType",
                      class: "form-select form-select-sm",
                      as: "select",
                      modelValue: driver.value.docType,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((driver.value.docType) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(types), (type, key) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: key,
                            value: type
                          }, _toDisplayString(type), 9, _hoisted_50))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('drivers.fields.document')), 1),
                    _createVNode(_unref(Field), {
                      name: "document",
                      modelValue: driver.value.document,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((driver.value.document) = $event))
                    }, {
                      default: _withCtx(({ field, errorMessage, meta }) => [
                        _createElementVNode("div", _hoisted_54, [
                          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "input-group-text" }, [
                            _createElementVNode("em", { class: "fas fa-id-card" })
                          ], -1)),
                          _withDirectives(_createElementVNode("input", _mergeProps({ class: "form-control form-control-sm" }, field, {
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            placeholder: _ctx.$t('common.placeholders.comment'),
                            "aria-label": "Document",
                            autocomplete: "none"
                          }), null, 16, _hoisted_55), [
                            [_vModelDynamic, field.value]
                          ])
                        ]),
                        (errorMessage && meta.dirty)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(errorMessage), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t('drivers.fields.status')), 1),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "cdmEnableDriver",
                        onChange: onEnable
                      }, null, 32),
                      _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t(driver.value.enabled_at ? 'common.fields.enabled' : 'common.fields.disabled')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('drivers.fields.payment_mode')), 1),
                    _createVNode(_unref(Field), {
                      name: "paymentMode",
                      class: "form-select form-select-sm",
                      as: "select",
                      modelValue: driver.value.paymentMode,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((driver.value.paymentMode) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          value: _unref(DriverPaymentMode).MONTHLY
                        }, _toDisplayString(_ctx.$t('common.placeholders.' + _unref(DriverPaymentMode).MONTHLY)), 9, _hoisted_66),
                        _createElementVNode("option", {
                          value: _unref(DriverPaymentMode).PERCENTAGE
                        }, _toDisplayString(_ctx.$t('common.placeholders.' + _unref(DriverPaymentMode).PERCENTAGE)), 9, _hoisted_67)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-secondary btn-sm",
                onClick: close
              }, _toDisplayString(_ctx.$t('common.actions.cancel')), 1),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-sm bg-gradient-info",
                disabled: submitting.value
              }, [
                (submitting.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_70))
                  : (_openBlock(), _createElementBlock("em", _hoisted_71)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.submit')), 1)
              ], 8, _hoisted_69)
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ])
    ])
  ]))
}
}

})